export function propagateEvents({ from, to, include, exclude, }) {
    const originalFromEmit = from.emit;
    const includeSet = new Set(include);
    const excludeSet = new Set(exclude);
    from.emit = (eventName, ...args) => {
        originalFromEmit.call(from, eventName, ...args);
        if (excludeSet.size && excludeSet.has(eventName)) {
            return;
        }
        if (!excludeSet.size && includeSet.size && !includeSet.has(eventName)) {
            return;
        }
        to.emit(eventName, ...args);
    };
    return () => {
        from.emit = originalFromEmit;
    };
}
